<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailRewardCategory' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
          :styleObject="brandDropDownStyle"
        ></BrandDropdown>
      </div>
      <div class="col-3">
        <label for="rewardTypeSelected">Reward Type</label>
        <multiselect
          id="rewardTypeSelected"
          v-model="rewardTypeSelected"
          :options="rewardTypeOptions"
          label="text"
          track-by="text"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col-3">
        <label for="statusSelected">Status</label>
        <multiselect
          id="statusSelected"
          v-model="statusSelected"
          :options="statusOptions"
          label="text"
          track-by="text"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col-3">
        <label for="searchKeyword">Keyword</label>
        <input
          id="searchKeyword"
          type="text"
          v-model="keyword"
          class="form-control"
          style="margin: 0.7rem 0"
        />
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-secondary"
          style="width: 100%; max-width: 131px"
          @click="resetFilter"
        >
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="searchRewardCategory"
        >
          OK
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listRewardCategories"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #table-caption v-if="listRewardCategories.length === 0">
          <h5 class="text-center pt-10">There is no reward category data</h5>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailRewardCategory',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import RewardCategoryService from "services/api/rewardCategory.service";
import fields from "./listRewardCategoryFields.json";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      rewardTypeOptions: [{ text: "REWARDS" }, { text: "PACKAGES" }],
      rewardTypeSelected: null,
      statusOptions: [{ text: "ACTIVE" }, { text: "INACTIVE" }],
      statusSelected: null,
      keyword: null,
      isSubmit: false,
      message: null,
      listRewardCategories: [],
      fields,
      brandDropDownStyle: {
        margin: "0.6rem 0",
      },
    };
  },

  async mounted() {
    this.isLoading = true;
    await this.getRewardCategories();
  },

  methods: {
    async getRewardCategories() {
      const param = this.getParams();

      await RewardCategoryService.getListRewardCategory(param)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItems;
          this.listRewardCategories = data.rewardCategories.map((r) => {
            return {
              ...r,
              rewardType: this.leadWithUpperCase(r.rewardType),
              status: this.leadWithUpperCase(r.status),
              dateCreated: this.setFormatDate(r.dateCreated),
              lastUpdated: this.setFormatDate(r.lastUpdated),
            };
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    getParams() {
      return {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        rewardType: this.rewardTypeSelected
          ? this.rewardTypeSelected.text
          : null,
        status: this.statusSelected ? this.statusSelected.text : null,
        key: this.keyword,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "id",
        sortType: this.sort.type || "desc",
      };
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    searchRewardCategory() {
      this.isLoading = true;
      this.getRewardCategories();
    },
    resetFilter() {
      this.brandSelected = null;
      this.rewardTypeSelected = null;
      this.statusSelected = null;
      this.keyword = null;
      this.getRewardCategories();
    },
    changePage() {
      this.getRewardCategories();
    },
    onChangeEntries() {
      this.getRewardCategories();
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getRewardCategories();
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },
    setFormatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
